import { useEffect } from "react";

const TawkToWidget = () => {
  useEffect(() => {
    if (window.location.href.includes("localhost:3000")) {
      return;
    }
    
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/63da546ec2f1ac1e2030ca3a/1go6djkpe";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default TawkToWidget;
